import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { isCheckBoxReferenceType } from 'app/area/codetable/item/screen-renderer/screen-pickers/reference/helpers';
import { CodeActionType, ReadOnlyType } from 'app/area/codetable/item/types';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const CheckedCode = (props: ScreenPickerProps) => {

  const { breadcrumbs, codeItem, updateByKey, resetValidation, codetableOptions, loadCodetableOptions,
    translation, validation, readOnlyConfig, actionType } = props;

  const isCodeAdding = codeItem && !isDefinedIncludingZero(codeItem.id);

  const isCodeDuplicating = actionType === CodeActionType.Duplicate;

  if (!isCheckBoxReferenceType(codeItem) || isCodeAdding || isCodeDuplicating) {
    return null;
  }

  const codetableId = codetableOptionsIds[ScreenPicker.checkedCode];

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(ScreenPicker.checkedCode);
    updateByKey(ScreenPicker.checkedCode, value);
    if (isDefinedIncludingZero(codeItem?.uncheckedCode?.value) &&
      codeItem?.checkedCode?.value !== value?.value &&
      codeItem?.checkedCode?.value === codeItem?.uncheckedCode?.value) {
      resetValidation(ScreenPicker.uncheckedCode);
    }
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableId, {
      ...loadOptionsParams,
      ...(!!codeItem && isDefinedIncludingZero(codeItem.id) && { categoryId: codeItem.id })
    });
  };

  const codeOptions = (!!codetableOptions[ScreenPicker.checkedCode] && codetableOptions[ScreenPicker.checkedCode].codes || []);
  const checkedCodeValidation = !!validation && !!validation[ScreenPicker.checkedCode] ? validation[ScreenPicker.checkedCode] : undefined;
  const finalValidation = {
    ...checkedCodeValidation,
    ...getDisabledValidation(codeItem?.checkedCode?.disabled, translation.selected_value_disabled)
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs, codeItem.id);

  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  return <CodeSinglePicker
    id={ScreenPicker.checkedCode}
    label={translation.checked_code}
    valueItem={codeItem && codeItem.checkedCode}
    searchRequired={false}
    required={!readOnly}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={codetableOptions[ScreenPicker.checkedCode] && codetableOptions[ScreenPicker.checkedCode].fetching}
    extraFooterButton={extraFooterButton}

    translation={translation}

    onLoadOptions={onLoadOptions}
    onChange={onChange}
    validation={finalValidation}
  />;
};
